/**
 * Chinese Classical ruleset. Kong is legal; scoring runs the real
 * `ScoreCalculator` (T12).
 */

import { calculateHandScore } from '../../scoring/ScoreCalculator.js';
import type { HandScore, Ruleset, ScoringContext } from './types.js';

export const ClassicalRuleset: Ruleset = {
  id: 'classical',
  kongEnabled: true,
  alternateWinShapes: true,
  scoreHand(context: ScoringContext): HandScore | null {
    return calculateHandScore(context);
  },
};
